import { useTheme } from '@mui/material';

import {
  CELL_HEIGHT,
  CELL_SPACING,
  CELL_WIDTH,
  CUSTOM_PADDING,
  LEFT_COLUMN,
} from '~/components/EmployeeCalendar/data';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    rowWrapper: {
      display: 'flex',
      flexWrap: 'nowrap',
    },
    nameCell: {
      width: `${LEFT_COLUMN}px`,
      flexShrink: 0,
      display: 'flex',
      alignItems: 'center',
    },
    userName: {
      textDecoration: 'none',
      padding: `${CUSTOM_PADDING}px`,
      display: 'flex',
      textTransform: 'initial',
      width: '100%',
      justifyContent: 'flex-start',
    },
    avatar: {
      width: `${CELL_WIDTH}px`,
      height: `${CELL_HEIGHT}px`,
      display: 'inline-block',
      marginRight: `${CELL_SPACING * 3}px`,
    },
    nameSpan: {
      justifyContent: 'center',
    },
    minNameCell: {
      width: '50px',
      flexShrink: 0,
      display: 'flex',
      alignItems: 'center',
      paddingRight: theme.spacing(1),
      overflow: 'hidden',
    },
    noData: {
      padding: theme.spacing(1),
      textAlign: 'center',
    },
  };
};
